function segments(hash) {
  return String(hash || '').replace(/^#\/?/, '').split('/').filter(Boolean);
}

export function parseRouteHash(hash) {
  const [rawPage = 'overview', id = null, returnJobId = null] = segments(hash);
  const page = rawPage || 'overview';
  return {
    page,
    candidateId: page === 'candidate' ? id : null,
    routeJobId: page === 'candidates' ? id : null,
    returnJobId: page === 'candidate' ? returnJobId : null,
  };
}

export function buildRouteHash(page, id = null, returnJobId = null) {
  if (page === 'candidate' && id) {
    return ['candidate', id, returnJobId].filter(Boolean).join('/');
  }
  if (page === 'candidates' && id) return `candidates/${id}`;
  return page;
}
